<template>
  <div>
    <div class="app-main-inner-row" style="padding-top: 10px;">
      <div class="filters">
        <el-form
          :inline="true"
          label-width="50px"
          label-position="left"
          @submit.native.prevent="filter.pageNum=1;toQuery()"
        >
          <el-form-item :label="$t('common.btn.query')">
            <el-input
              v-model="filter.likeName"
              no="queryInput"
              :placeholder="$t('common.tips.fuzzySearch')"
              style="width:310px"
            />
          </el-form-item>
        </el-form>
      </div>
      <div class="triggers">
        <el-button no="query" type="primary" @click="filter.pageNum=1;toQuery()">{{ $t('common.btn.query') }}</el-button>
        <el-button no="new" type="primary" @click="showEditDialog(true)">{{ $t('common.btn.new') }}</el-button>
        <el-button no="edit" type="primary" @click="showEditDialog(false)">{{ $t('common.btn.edit') }}</el-button>
        <el-button no="delete" size="mini" type="danger" @click="remove">{{ $t('common.btn.delete') }}</el-button>
        <el-button no="exportExcel" type="primary" @click="exportExcel">{{ $t('common.btn.exportExcel') }}</el-button>
      </div>
    </div>
    <div class="app-main-inner-row row-grid">
      <cargo-ag-grid
        no="grid"
        config-module="101316"
        :grid-params.sync="girdParams"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
      />
    </div>
    <div class="app-main-inner-row row-pagination">
      <cargo-pagination
        v-show="total>0"
        no="pagination"
        :total="total"
        :page.sync="filter.pageNum"
        :limit.sync="filter.pageSize"
        @pagination="toQuery"
      />
    </div>
    <!-- 编辑弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="editDialog.visible"
      :title="editDialog.title"
      width="400px"
      :close-on-click-modal="false"
    >
      <div class="app-main-inner-row" style="padding-bottom: 10px;">
        <el-form label-width="100px" label-position="left">
          <el-form-item :label="$t('baseInfo.basicData.otherChargeItem.chargeItemCode')">
            <el-input v-model="editDialog.form.chargeItemCode" no="chargeItemCode" style="width: 160px" />
          </el-form-item>
          <el-form-item :label="$t('baseInfo.basicData.otherChargeItem.chineseName')">
            <el-input v-model="editDialog.form.chineseName" no="chineseName" style="width: 160px" />
          </el-form-item>
          <el-form-item :label="$t('baseInfo.basicData.otherChargeItem.measure')">
            <el-select v-model="editDialog.form.measure" no="measure" style="width: 160px">
              <el-option
                v-for="item in measures"
                :key="item.code"
                :label="$store.getters.language === 'zh' ? item.chineseName : item.englishName"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('baseInfo.basicData.otherChargeItem.defaultApPrice')">
            <el-input-number
              v-model="editDialog.form.defaultApPrice"
              no="defaultApPrice"
              :controls="false"
              :min="0"
              style="width: 160px"
              @blur="defaultApPriceBlur"
            />
          </el-form-item>
          <el-form-item :label="$t('baseInfo.basicData.otherChargeItem.remark')">
            <el-input v-model="editDialog.form.remark" no="remark" type="textarea" :rows="3" style="width: 160px" />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button no="save" type="primary" @click="save">{{ $t('common.btn.save') }}</el-button>
        <el-button no="cancel" @click="editDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getOtherChargeItemList, saveOtherChargeItem, delOtherChargeItem } from '@/api/basicData/otherChargeItem'
import { getLoading } from '@/utils/utilBaseElement'
import * as AirExportConstants from '@/class/cargo/model/parameters/AirExportConstants'
import ColumnUtils from '@/utils/ColumnUtils'

export default {
  name: 'OtherChargeItem',
  data() {
    return {
      filter: {
        likeName: '',
        pageNum: 1,
        pageSize: 50
      },
      total: 0,
      girdParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        defaultColDef: {
          menuTabs: [], // 去掉每列的菜单
          filter: true
        }
      },
      columnDefs: [
        {
          headerName: '',
          checkboxSelection: true,
          width: 55,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('baseInfo.basicData.otherChargeItem.chargeItemCode'),
          field: 'chargeItemCode',
          width: 100
        },
        {
          headerName: this.$t('baseInfo.basicData.otherChargeItem.chineseName'),
          field: 'chineseName',
          width: 200
        },
        {
          headerName: this.$t('baseInfo.basicData.otherChargeItem.measure'),
          field: 'measure',
          width: 200,
          cellRenderer: params => {
            return ColumnUtils.columnLabelFunc(this.measures, params.value)
          }
        },
        {
          headerName: this.$t('baseInfo.basicData.otherChargeItem.defaultApPrice'),
          field: 'defaultApPrice',
          width: 150
        },
        {
          headerName: this.$t('baseInfo.basicData.otherChargeItem.remark'),
          field: 'remark',
          width: 200
        }
      ],
      rowData: null,
      measures: AirExportConstants.OTHER_CHARGE_ITEM_MEASURE,
      editDialog: {
        visible: false,
        title: '',
        form: {
          uuid: '',
          chargeItemCode: 'chargeWeight',
          chineseName: '',
          measure: '',
          defaultApPrice: '',
          remark: ''
        }
      }
    }
  },
  computed: {
    gridApi() {
      return this.girdParams.api
    }
  },
  created() {
  },
  methods: {
    onShow() {
      if (this.rowData === null) {
        this.rowData = []
        this.toQuery()
      }
    },
    toQuery() {
      const self = this
      const loading = getLoading()
      getOtherChargeItemList(self.filter).then(res => {
        if (self.gridApi) {
          self.gridApi.setRowData(res.data.list)
        } else {
          self.rowData = res.data.list
        }
        self.filter.pageNum = res.data.pageNum
        self.filter.pageSize = res.data.pageSize
        self.total = Number(res.data.total)
      }).finally(() => loading.close())
    },
    showEditDialog(isNew) {
      if (isNew) {
        this.editDialog.form = {
          uuid: '',
          chargeItemCode: '',
          chineseName: '',
          measure: 'chargeWeight',
          defaultApPrice: '',
          remark: ''
        }
        this.editDialog.title = this.$t('CargoMsg.Cargo_NewTo') + this.$t('CargoMsg.Cargo_OtherChargeItem')
      } else {
        const rows = this.gridApi.getSelectedRows()
        if (rows.length === 0) {
          this.$message.warning(this.$t('common.tips.hasOneAtleast'))
          return
        }
        this.editDialog.form = { ...rows[0] }
        this.editDialog.title = this.$t('CargoMsg.Cargo_EditTo') + this.$t('CargoMsg.Cargo_OtherChargeItem')
      }
      this.editDialog.visible = true
    },
    defaultApPriceBlur() {
      const form = this.editDialog.form
      const val = Number(form.defaultApPrice)
      if (isNaN(val)) {
        form.defaultApPrice = ''
        return
      }
      form.defaultApPrice = val.toFixed(0)
    },
    save() {
      const self = this
      const form = self.editDialog.form
      if (!form.chargeItemCode) {
        self.$message.warning(self.$t('baseInfo.basicData.otherChargeItem.chargeItemCodeCheck'))
        return
      }
      if (!form.chineseName) {
        self.$message.warning(self.$t('baseInfo.basicData.otherChargeItem.chineseNameCheck'))
        return
      }
      saveOtherChargeItem(form).then(res => {
        if (!form.uuid) {
          self.filter.pageNum = 1
        }
        self.toQuery()
        self.editDialog.visible = false
        self.$message.success(self.$t('common.tips.saveSuccess'))
      }).catch(() => {
        self.editDialog.visible = false
      })
    },
    remove() {
      const self = this
      const rows = self.gridApi.getSelectedRows()
      if (rows.length === 0) {
        self.$message.warning(self.$t('common.tips.hasOneAtleast'))
        return
      }
      self.$confirm(self.$t('common.tips.confirmDelete'), self.$t('common.tips.prompt'), {
        confirmButtonText: self.$t('common.btn.ok'),
        cancelButtonText: self.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        self.syncRemove(rows, 0)
      }).catch(() => { })
    },
    syncRemove(rows, index) {
      const self = this
      if (index < rows.length) {
        delOtherChargeItem(rows[index].uuid).then(res => {
          self.syncRemove(rows, index + 1)
        }).catch(() => {
          if (index > 0) {
            self.filter.pageNum = 1
            self.toQuery()
          }
        })
      } else {
        self.filter.pageNum = 1
        self.toQuery()
        self.$message.success(self.$t('common.tips.deleteSuccess'))
      }
    },
    exportExcel() {
      const self = this
      const rows = self.gridApi.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      import('@/vendor/Export2Excel').then(excel => {
        const tHeader = [
          self.$t('baseInfo.basicData.otherChargeItem.chargeItemCode'),
          self.$t('baseInfo.basicData.otherChargeItem.chineseName'),
          self.$t('baseInfo.basicData.otherChargeItem.measure'),
          self.$t('baseInfo.basicData.otherChargeItem.defaultApPrice'),
          self.$t('baseInfo.basicData.otherChargeItem.remark')
        ]
        const filterVal = ['chargeItemCode', 'chineseName', 'measureStr', 'defaultApPrice', 'remark']
        const data = self.formatJson(filterVal, rows)
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: 'OtherChargeItem'
        })
      })
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    }
  }
}
</script>

<style>
</style>
